export const getDecimalValue = (value, decimals = 2) => { // 0.345 => 0.35 | 0.344 => 0.34
  decimals = 10 ** decimals;
  return (Math.round((parseFloat(value) + Number.EPSILON) * decimals) / decimals);
}